import React, { useState, useEffect } from "react";
import ApiGroupForm from "./ApiGroupForm";
import {
  getApiUserGroupforEdit,
  addApiUserGroup,
  updateApi,
} from "../../../services/MasterAdmin & ApiUSer/apiUserGroupService";
import { MdEdit } from "react-icons/md";
import { NotificationManager } from "react-notifications";
import { format } from "date-fns";

const EditApiGroup = (props) => {
  const [userGroupList, setUserGroupList] = useState([]);
  const [tagMarkupList, setTagMarkupList] = useState([]);
  const [commissionMarkupList, setCommissionMarkupList] = useState([]);
  const [showEditorDialog, setShowEditorDialog] = useState(false);
  const [dialogValues, setDialogValues] = useState(null);

  const updatePageData = async () => {
    const { data: ApiuserGroupData } = await getApiUserGroupforEdit();
    setUserGroupList([...ApiuserGroupData]);
  };

  const toggleEditorDialog = (arg) => {
    if (arg && arg.toString()) {
      setShowEditorDialog(arg);
      setDialogValues(null);
    } else {
      setShowEditorDialog(!showEditorDialog);
      setDialogValues(null);
    }
  };

  const handleEditContact = (item) => {
    const { id, name, validTo, tagMarkup, commissionMarkup } = item;
    const editModel = {
      id,
      name,
      validTo: format(
        new Date(validTo ? validTo : new Date()).getTime(),
        "yyyy-MM-dd"
      ),
      tagMarkupId: 1,
      commissionMarkupId: 1,
    };

    setDialogValues(editModel);
    setShowEditorDialog(true);
  };

  const handleFormSubmit = async (values) => {
    let res;
    if (!dialogValues) {
      const res = await addApiUserGroup(values);
      if (res.status == "Success") {
        toggleEditorDialog(false);
        NotificationManager.success(
          "Data has been saved successfully.",
          "Saved!",
          5000
        );
        setTimeout(async () => {
          await props.refresh();
        }, 100);
      }
    } else {
      const res = await updateApi(values);
      if (res.status == "Success") {
        toggleEditorDialog(false);
        NotificationManager.success(
          "Data has been updated successfully.",
          "Updated!",
          5000
        );
        setTimeout(async () => {
          await props.refresh();
        }, 100);
      }
    }
  };

  // useEffect(() => {
  //   updatePageData();
  // }, []);

  return (
    <>
      {props.type === "addUser" ? (
        <button
          type="button"
          className="btn btn-primary btn-md m-1"
          onClick={() => toggleEditorDialog()}
        >
          <i className="i-Add-User text-white me-2"></i> Add API Markup Group
        </button>
      ) : (
        <div className="cursor-pointer">
          <MdEdit
            className="text-success"
            size={18}
            onClick={() => handleEditContact(props.data)}
          />
        </div>
      )}

      <ApiGroupForm
        tagMarkup={tagMarkupList}
        commissionMarkup={commissionMarkupList}
        show={showEditorDialog}
        toggleEditorDialog={toggleEditorDialog}
        initialValues={dialogValues}
        handleFormSubmit={handleFormSubmit}
      />
    </>
  );
};

export default EditApiGroup;
